import { Badge } from "@its-engineering-and-development/ui-foundation/components";
import type { PolicyFieldRequirement } from "@app/types/policy";

const BADGE_CONFIG: Record<PolicyFieldRequirement, { color: "error" | "gray" | "warning"; label: string }> = {
    mandatory: { color: "error", label: "Mandatory" },
    optional: { color: "gray", label: "Optional" },
    "strongly-recommended": { color: "warning", label: "Strongly Recommended" },
};

export function PolicyFieldBadge({ requirement }: { requirement: PolicyFieldRequirement }) {
    const { color, label } = BADGE_CONFIG[requirement];

    return (
        <Badge type="pill-color" color={color} size="sm">
            {label}
        </Badge>
    );
}
